/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEmbedTokenRequest } from '../../models/create-embed-token-request';
import { EmbedTokenDto } from '../../models/embed-token-dto';

export interface EmbedsDashboardIdPost$Plain$Params {
  dashboardId: string;
      body?: CreateEmbedTokenRequest
}

export function embedsDashboardIdPost$Plain(http: HttpClient, rootUrl: string, params: EmbedsDashboardIdPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenDto>> {
  const rb = new RequestBuilder(rootUrl, embedsDashboardIdPost$Plain.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmbedTokenDto>;
    })
  );
}

embedsDashboardIdPost$Plain.PATH = '/embeds/{dashboardId}';
